import { useState, useEffect } from 'react';
import api from '../api/axios';

function Toggle({ on, onChange }) {
  return (
    <div onClick={onChange} style={{ width: 44, height: 24, borderRadius: 12, background: on ? '#25D366' : '#d1d5db', position: 'relative', cursor: 'pointer', transition: 'background 0.2s', display: 'inline-block', flexShrink: 0 }}>
      <div style={{ position: 'absolute', top: 3, left: on ? 22 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }} />
    </div>
  );
}

function EditModal({ user, onClose, onSave }) {
  const [form, setForm] = useState({ waba_id: user.waba_id || '', phone_number_id: user.phone_number_id || '', access_token: user.access_token || '', verify_pin: user.verify_pin || '' });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await api.post('/admin/users/' + user.id + '/waba', form);
      onSave(form);
      onClose();
    } catch(e) { alert('Failed: ' + (e.response?.data?.error || e.message)); }
    setSaving(false);
  };
  const inp = { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13, boxSizing: 'border-box', marginBottom: 12 };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 480, boxShadow: '0 20px 50px rgba(0,0,0,0.2)' }}>
        <h3 style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>Edit WABA Details</h3>
        <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 20 }}>{user.email}</p>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>WABA ID</label>
        <input value={form.waba_id} onChange={e => setForm({...form, waba_id: e.target.value})} placeholder="e.g. 118472705748..." style={inp} />
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Phone Number ID</label>
        <input value={form.phone_number_id} onChange={e => setForm({...form, phone_number_id: e.target.value})} placeholder="e.g. 942199335649..." style={inp} />
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Access Token</label>
        <textarea value={form.access_token} onChange={e => setForm({...form, access_token: e.target.value})} placeholder="EAAUUw..." rows={3} style={{ ...inp, resize: 'vertical', fontFamily: 'monospace', fontSize: 11 }} />
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Verify PIN (6-digit)</label>
        <input value={form.verify_pin} onChange={e => setForm({...form, verify_pin: e.target.value})} placeholder="e.g. 123456" maxLength={6} style={inp} />
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#f9fafb', cursor: 'pointer', fontWeight: 600 }}>Cancel</button>
          <button onClick={save} disabled={saving} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: saving ? '#9ca3af' : '#25D366', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>{saving ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminPanel() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editUser, setEditUser] = useState(null);

  useEffect(() => {
    api.get('/admin/users').then(r => {
      setUsers(Array.isArray(r.data) ? r.data : (r.data?.users || []));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const toggleMessaging = async (userId, current) => {
    try {
      await api.patch('/admin/users/' + userId + '/toggle', { is_active: current ? 0 : 1 });
      setUsers(u => u.map(x => x.id === userId ? { ...x, is_active: current ? 0 : 1 } : x));
    } catch(e) { alert('Toggle failed'); }
  };

  const setLimit = async (userId, limit) => {
    try {
      await api.patch('/admin/users/' + userId + '/limit', { new_limit: parseInt(limit) });
      setUsers(u => u.map(x => x.id === userId ? { ...x, message_limit: parseInt(limit) } : x));
    } catch(e) { alert('Limit update failed'); }
  };

  const th = { padding: '10px 14px', fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', borderBottom: '1px solid #e5e7eb', textAlign: 'left', whiteSpace: 'nowrap' };
  const td = { padding: '12px 14px', fontSize: 13, borderBottom: '1px solid #f3f4f6', verticalAlign: 'middle' };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>Admin Panel - Client Management</h2>
      <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflowX: 'auto' }}>
        {loading ? <p style={{ textAlign: 'center', padding: 24, color: '#9ca3af' }}>Loading...</p> : (
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 1000 }}>
            <thead>
              <tr>{['ID','Email','Role','WABA Status','Messaging','Credits Used','Credit Limit','Set Limit','Joined','Actions'].map(h => <th key={h} style={th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td style={td}>{u.id}</td>
                  <td style={td}>{u.email}</td>
                  <td style={td}>
                    <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: u.role === 'admin' ? '#ede9fe' : '#dbeafe', color: u.role === 'admin' ? '#6d28d9' : '#1d4ed8' }}>{u.role}</span>
                  </td>
                  <td style={td}>
                    {u.waba_id ? (
                      <div>
                        <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: '#f0fdf4', color: '#16a34a' }}>Connected</span>
                        <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{u.waba_id?.substring(0,12)}...</div>
                      </div>
                    ) : (
                      <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: '#fef2f2', color: '#dc2626' }}>Not Connected</span>
                    )}
                  </td>
                  <td style={td}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                      <Toggle on={!!u.is_active} onChange={() => toggleMessaging(u.id, u.is_active)} />
                      <span style={{ fontSize: 11, color: u.is_active ? '#25D366' : '#9ca3af' }}>{u.role === 'admin' ? 'Admin' : u.is_active ? 'Active' : 'Blocked'}</span>
                    </div>
                  </td>
                  <td style={td}><span style={{ color: '#25D366', fontWeight: 700 }}>{u.messages_used ?? 0}</span></td>
                  <td style={td}><span style={{ color: '#25D366', fontWeight: 700 }}>{u.message_limit >= 999999 ? 'Unlimited' : u.message_limit}</span></td>
                  <td style={td}>
                    <input type="number" defaultValue={u.message_limit >= 999999 ? '' : u.message_limit} placeholder="e.g. 1000"
                      style={{ width: 80, padding: '6px 8px', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 12 }}
                      onBlur={e => { if (e.target.value) setLimit(u.id, e.target.value); }} />
                  </td>
                  <td style={td}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '-'}</td>
                  <td style={td}>
                    <button onClick={() => setEditUser(u)} style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: '#2563eb', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                      Edit WABA
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {editUser && <EditModal user={editUser} onClose={() => setEditUser(null)} onSave={form => { setUsers(u => u.map(x => x.id === editUser.id ? {...x, ...form} : x)); setEditUser(null); }} />}
    </div>
  );
}
